import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import Loader from '../Loader';

const Resetpassword = () => {
    const { register, handleSubmit, formState: { errors }, reset, watch } = useForm({ defaultValues: { newPassword: "", confirmPassword: "" } });
    const newPassword = watch("newPassword");
    const { token } = useParams();
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const handleChangePassword = (data) => {
        if (data.newPassword !== data.confirmPassword) {
            return toast("Confirm-Password do not match", {
                theme: "light",
                type: "warning",
                position: "top-right"
            });
        }
        setLoader(true);
        axios({
            method: "POST",
            url: `${process.env.REACT_APP_BASE_URL}/user/reset-password`,
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                token: token,
                password: data.newPassword
            }),
        }).then(res => {
            setLoader(false);
            reset({ confirmPassword: "", newPassword: "" });
            toast(res.data.message, {
                theme: "light",
                type: "success",
                position: "top-right"
            });
            navigate('/login');
        }).catch(err => {
            setLoader(false);
            if (err?.response?.data?.errors) {
                return toast(err?.response?.data?.errors?.[0].msg || "Error 500", {
                    theme: "light",
                    type: "error",
                    position: "top-right",
                });
            } else {
                return toast(err?.response?.data?.message || err?.message || "Reset password unsuccessful. The server is not responding.", {
                    theme: "light",
                    type: "error",
                    position: "top-right",
                });
            }
        });
    }
    return (
        <>
            <section className='form-section changepassword'>
                <Container>
                    <Row className="justify-content-center">
                        <Col xxl={5} lg={6} md={8} sm={10}>
                            <div className="boxwrap">
                                <h2 className='text-gradient'>Reset Password</h2>
                                <Form onSubmit={handleSubmit(handleChangePassword)} className="row">

                                    <Form.Group as={Col} md="12" className="mb-3" controlId="changepassword-Password">
                                        <Form.Label>New password <span>*</span></Form.Label>
                                        <Form.Control
                                            type="password" placeholder='Please enter new password'
                                            {...register("newPassword", {
                                                required: { message: "New-Password is require", value: true },
                                                pattern: { message: "New-Password is too weak", value: /^(?=.*\d)(?=.*[a-zA-Z]).{6,}$/g }
                                            })} />
                                        {errors.newPassword ? <p className='errMsg'>{errors.newPassword.message}</p> : null}
                                    </Form.Group>

                                    <Form.Group as={Col} md="12" className="mb-3" controlId="changepassword-Password">
                                        <Form.Label>Confirm new password <span>*</span></Form.Label>
                                        <Form.Control
                                            type="password" placeholder='Please reenter your new password'
                                            {...register("confirmPassword", {
                                                required: { message: "Confirm-Password is require", value: true },
                                                validate: (value) => {
                                                    if (value !== newPassword) {
                                                        return "Password do not match";
                                                    }
                                                    return true;
                                                }
                                            })} />
                                        {errors.confirmPassword ? <p className='errMsg'>{errors.confirmPassword.message}</p> : null}
                                    </Form.Group>

                                    <div className="d-flex align-items-center justify-content-between gap-3">
                                        <button onClick={() => reset({ newPassword: "", oldPassword: "" })} type="button" className="button yellow w-50 py-3">Cancel</button>
                                        <button type="submit" className="button blue w-50 py-3">Submit</button>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Loader show={loader}/>
        </>
    )
}

export default Resetpassword